import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TableHeadingTypography = ({
  text = 'Heading',
  variant = 'h5',
  fontWeight = '500',
  className = 'fs-18',
  mb = 0,
  sx = {}
}) => {
  const theme = useTheme();

  return (
    <Typography
      className={className}
      variant={variant}
      fontWeight={fontWeight}
      mb={mb}
      sx={{
        color: theme.palette.custom.tableHeadingText,
        ...sx,
      }}
    >
      {text}
    </Typography>
  );
};

export default TableHeadingTypography;
